import { findActivity, activitiesLength } from '@/store/activities/getters'
import { del, get, getAll, patch, post } from '@/utils/api'

const normalizeActivity = record => ({
  id: record.getId(),
  description: record.get('description'),
  date: record.get('date'),
  duration: record.get('duration'),
  subject: record.get('subject'),
  student: record.get('student')
})

const getActivities = ({ commit, state }, force) => {
  if (activitiesLength(state) < 1 || !!force) {
    getAll('Activities').then(activities => {
      const returnActivities = activities.map(s => normalizeActivity(s))
      commit('SET_ACTIVITIES', returnActivities)
      commit('IS_LOADED')
    })
  }
}

const getActivity = ({ commit }, id) => {
  const ActivityFromState = findActivity(id)
  if (ActivityFromState) {
    return ActivityFromState
  }

  get('Activities', id).then(activity => {
    commit('SET_ACTIVITY', normalizeActivity(activity))
  })
}

const addActivity = ({ commit }, activity) => {
  const thisActivity = { ...activity }
  if (activity.subject && !Array.isArray(activity.subject)) {
    thisActivity.subject = [activity.subject]
  }
  if (activity.student && !Array.isArray(activity.student)) {
    thisActivity.student = [activity.student]
  }
  post('Activities', { fields: thisActivity }).then(activities => {
    activities.forEach(s => {
      commit('ADD_ACTIVITY', normalizeActivity(s))
    })
  })
}

const deleteActivity = ({ commit }, id) => {
  del('Activities', id).then(s => {
    commit('DELETE_ACTIVITY', s.id)
  })
}

const editActivity = ({ commit }, activity) => {
  patch('Activities', activity).then(s => {
    commit('EDIT_ACTIVITY', normalizeActivity(s))
  })
}

export default {
  addActivity,
  deleteActivity,
  editActivity,
  getActivity,
  getActivities
}
